import * as React from 'react';
import { ContainerEmailPreview } from './ContainerEmailPreview';
import { DocumentRequiredI } from '@/interfaces';

interface DocumentRequiredPreviewI {
	caseName: string;
	content: string;
	documentList: DocumentRequiredI[];
}

export const DocumentRequiredPreview: React.FC<DocumentRequiredPreviewI> = ({
	caseName,
	content,
	documentList,
}) => {
	const [htmlContent, setHtmlContent] = React.useState<string>('');
	const [stylesContent, setStylesContent] = React.useState<string>('');

	React.useEffect(() => {
		const fetchHtml = async (): Promise<void> => {
			// Get the content of the HTML file
			const response = await fetch(
				'/email-templates/client/claim-document-required.html'
			);
			const html = await response.text();

			// Create a DOM to render the content
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Extraer el div con id="principalContent"
			const contentElement = doc.querySelector('#principalContent');

			if (contentElement) {
				// Replace [Case Name]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'[Case Name]',
					caseName
				);

				// Replace [Content]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'[Content]',
					content
				);

				// Remove [Customizable] from the list
				const listItems = contentElement.querySelectorAll('li');
				listItems.forEach((item) => {
					if (item.textContent === '[Customizable]') {
						item.remove(); // Eliminar el elemento del DOM
					}
				});

				if (documentList.length > 0) {
					// Obtener la lista padre (ul o ol) para agregar más elementos
					const parentList =
						contentElement.querySelector('ul') ||
						contentElement.querySelector('ol');

					if (parentList) {
						// Array con más registros para agregar
						const additionalItems = documentList;

						// Agregar los nuevos elementos a la lista
						additionalItems.forEach((doc) => {
							const newItem = document.createElement('li'); // Crear nuevo <li>
							newItem.textContent = doc.name; // Asignar el texto
							parentList.appendChild(newItem); // Agregarlo a la lista
						});
					}
				}

				// Deshabilitar todos los enlaces <a> y aplicar estilos
				const links = doc.querySelectorAll('a');
				links.forEach((link) => {
					link.removeAttribute('href');
					link.style.opacity = '0.7';
					link.style.pointerEvents = 'none';
					link.style.cursor = 'not-allowed';
				});
			}
			setHtmlContent(contentElement?.outerHTML || '');

			// Extract styles from file
			const styleElements = doc.querySelectorAll('style');
			let extractedStyles = '';
			styleElements.forEach((style) => {
				extractedStyles += style.textContent;
			});
			setStylesContent(extractedStyles);
		};

		fetchHtml();
	}, []);

	return (
		<ContainerEmailPreview type="email">
			{/* Inject the extracted styles and add flex so it looks good in preview */}
			<style>
				{`
					${stylesContent}
					.centerAlign {
						text-align: center;
						margin: 0 auto 0 auto;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				`}
			</style>
			<div
				className="mb-10"
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</ContainerEmailPreview>
	);
};
